import { type FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DiscoverAndActivateImage from './DiscoverAndActivateImage'

const copy = {
  heading: `Discover and activate the best audiences for every campaign`,
  description: `CustomerAI Predictions includes pre-built Predictive Audiences to inspire new campaign ideas and help you quickly create AI-powered audiences in just a few clicks.`,
  list: [
    {
      title: `Ready to buy audiences`,
      description: `Includes customers who are most likely to purchase.`,
    },
    {
      title: `Long shots audiences`,
      description: `Includes customers who have previously interacted with your brand but aren't currently engaged.`,
    },
    {
      title: `High LTV audiences`,
      description: `Includes customers with high predictive lifetime value.`,
    },
    {
      title: `Potential VIPs audiences`,
      description: `Includes recently active customers with high predictive lifetime value as well as a high likelihood to purchase.`,
    },
    {
      title: `Dormant audiences`,
      description: `Includes inactive customers who are unlikely to purchase.`,
    },
  ],
}

const DiscoverAndActivate: FC = () => {
  return (
    <>
      <SectionBase variant="noCopy">
        <StyledCopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledCopyTextBase>
      </SectionBase>
      <StyledSectionBase variant="2Col" reverse={true}>
        <Section.Copy>
          <ColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p">{description}</CopyText.Description>
              </CopyTextBase>
            ))}
          </ColumnTrack>
        </Section.Copy>
        <Section.Contents>
          <DiscoverAndActivateImage />
        </Section.Contents>
      </StyledSectionBase>
    </>
  )
}

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
  margin: 0 auto;
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
  }
`

export default DiscoverAndActivate
